import * as React from 'react';
import './ErrorMessage.css';
//import { Icon } from '@fluentui/react-react/lib/Icon';
import { Icon } from "@fluentui/react";

export interface IFieldErrorMessageProps {
  errorMessage: string;
  className?: string;
}

export default class FieldErrorMessage extends React.Component<IFieldErrorMessageProps> {
  public render(): JSX.Element {
    const {
      errorMessage,
      className
    } = this.props;
    if (errorMessage !== undefined && errorMessage !== null && errorMessage !== '') {
      return (
        <div aria-live="assertive">
          <p className={`ms-TextField-errorMessage errorMessage ${className || ''}`}>
            <Icon iconName='Error' className={'errorIcon'} />
            <span data-automation-id="error-message">{errorMessage}</span>
          </p>
        </div>
      );
    } else {
      return null;
    }
  }
}
